import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elevated%20fashion%20discovery%20concept%20with%20neatly%20arranged%20sneakers%20hoodies%20accessories%20on%20warm%20sand%20cream%20textured%20surface%2C%20soft%20golden%20morning%20light%20streaming%20from%20upper%20left%20corner%2C%20clean%20modern%20editorial%20product%20photography%20with%20delicate%20fabric%20draping%2C%20warm%20earthy%20beige%20cream%20and%20soft%20terracotta%20palette%2C%20aspirational%20curated%20collection%20aesthetic%20with%20organic%20texture%20elements%2C%20minimalist%20organized%20composition%2C%20airy%20sophisticated%20atmosphere&width=1600&height=900&seq=hero-v2-2026-fresh&orientation=landscape"
          alt="Sugargoo Spreadsheet fashion product discovery"
          className="w-full h-full object-cover object-top"
          title="Sugargoo Spreadsheet - Product Discovery Database"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center py-20 md:py-24">
        <div className="inline-flex items-center gap-2 bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-full px-4 py-1.5 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
          <span className="text-xs md:text-sm font-medium text-background-50/90 whitespace-nowrap">Updated Daily · 1000+ Verified Finds</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight text-balance mb-5">
          The Ultimate Sugargoo Spreadsheet 2026
        </h1>

        <p className="text-sm md:text-lg text-background-50/80 max-w-2xl mx-auto leading-relaxed mb-8">
          Find thousands of trending products, verified finds, QC photos, and smart shopping guides — all in one organized database. Your shortcut to discovering the best items from global marketplaces.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto bg-primary-500 text-background-50 px-8 py-3.5 rounded-md text-sm md:text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap shadow-lg shadow-primary-500/25"
          >
            Sugargoo Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto bg-background-50 text-foreground-900 px-8 py-3.5 rounded-md text-sm md:text-base font-semibold hover:bg-background-100 transition-all whitespace-nowrap"
          >
            Buy It Now
          </a>
          <button
            onClick={() => navigate('/sugargoo-spreadsheet-guide')}
            className="w-full sm:w-auto border-2 border-background-50/40 text-background-50 px-8 py-3.5 rounded-md text-sm md:text-base font-semibold hover:bg-background-50/10 transition-all whitespace-nowrap"
          >
            Read Full Guide
          </button>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-10">
          {['Updated Regularly', 'Beginner Friendly', 'Product Research Database', 'Shopping Knowledge Hub'].map((badge) => (
            <span key={badge} className="flex items-center gap-1.5 text-xs md:text-sm text-background-50/70 whitespace-nowrap">
              <i className="ri-check-line text-accent-400 text-sm"></i>
              {badge}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}